import { Host } from '@wix/sdk';
import { ActionFactoryWithPlatformContext } from '../types';
import { EditorPointer } from '@wix/editorx-core-api';
import { CompRef } from '@wix/document-services-types';

export const editTextPanelActionFactory: ActionFactoryWithPlatformContext = ({
  actionPanelAPI,
  editorPlatformPackagesBridge,
  editorPointer,
  editorPointerAPI,
  componentsAPI,
}) => ({
  // TODO: add translation key
  actionName: 'editText',
  displayName: 'Edit text',
  tags: [],
  execute: async () => {
    editorPlatformPackagesBridge?.PlatformEditTextPanelAPI?.openFloatingPanel({
      getSDKHost: actionPanelAPI.getHost as () => Promise<Host>,
      editorPointer,
      editorPointerAPI,
      componentsAPI,
    });
  },
});
